module.exports = __webpack_public_path__ + "static/img/ent-13.c698803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-13.jpg
// module id = tMHc
// module chunks = 51